<template>
  <div class="MappingQuestionsContainer">
    <h2 class="Heading">
      Conditional Logic (Optional)
    </h2>
    <section>
      <div class="ConditionalContainer">
        <div class="Notice Notice--info">
          <p>Define a condition that will make a web form record <b>TO NOT</b> be sent.</p>
        </div>
        <rmp-autocomplete-select
          v-model="html_form_input_id"
          label="Do NOT send data if"
          index="html_form_input_id"
          class="u-noMargin"
          option-key="label_without_html_tags"
          :items="eventQuestions"
        />

        <div
          v-if="!isCheckboxTypeQuestion"
          class="Logic u-flex"
        >
          <rmp-autocomplete-select
            v-model.trim="constraint"
            label="Condition"
            :items="constraintOptions"
            index="value"
            option-key="label"
          />
          <rmp-input
            v-model="value"
            label="Value(s)"
          />
        </div>

        <div
          v-else
          class="CheckboxTypeDropdown"
        >
          <rmp-autocomplete-select
            v-model="value"
            style="width: 150px"
            label="Is answered: "
            index="value"
            option-key="label"
            :items="[{label:'Yes', value: '1'}, {label: 'No', value: '0' }]"
          />
        </div>
      </div>
      <div class="Footer u-flex u-flex-spaceBetween">
        <button
          class="Button Button--green-outline"
          @click="$emit('conditional-logic:back-navigation')"
        >
          Back
        </button>
        <button
          class="Button Button--transparent u-floatLeft ResetDeliveryCriteria"
          title="Clearing your conditional delivery settings"
          @click="clearConditionalLogic"
        >
          Reset
        </button>
        <div class="">
          <span class="StepNumber">{{ stepNumber }}</span>
          <button
            class="Button Button--green"
            @click="handleSubmit"
          >
            {{ buttonText }}
          </button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import RmpAutocompleteSelect from '@rmpenterprise/form-autocomplete-select';
import RmpInput from '@rmpenterprise/form-input';

export default {
  components: {
    RmpAutocompleteSelect,
    RmpInput,
  },
  props: {
    integration: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      html_form_input_id: null,
      constraint: null,
      value: null,
      constraintOptions: [
        { label: 'Equals to', value: 'equals' },
        { label: 'Not equal to', value: 'notEquals' },
        { label: 'Contains', value: 'contains' },
        { label: 'Not contains', value: 'notContains' },
        // { label: 'Is visible', value: 'displayed' },
      ],
    };
  },
  computed: {
    ...mapState('events', {
      eventQuestions: (state) => state.event.questions,
    }),
    stepNumber() {
      if (this.isZapierIntegration) return '2/3';
      return '2/2';
    },
    buttonText() {
      const existingIntegration = this.integration.id !== undefined;

      if (this.isZapierIntegration) {
        if (existingIntegration) {
          return 'Update Conditional Logic';
        }
        if (this.html_form_input_id === null) {
          return 'Continue without logic';
        }
        return 'Add Conditonal Logic';
      }

      if (!existingIntegration) {
        return 'Create Integration';
      }
      return 'Update Integration';
    },
    isZapierIntegration() {
      return this.integration.web_forms_integration_type_uuid === 'zapier' || this.integration.uuid === 'zapier';
    },
    integrationQuestionList() {
      return { ...this.integrations.filter((integrationType) => this.integration.name === integrationType.name)[0] };
    },
    isCheckboxTypeQuestion() {
      const question = this.eventQuestions.filter((eventQuestion) => {
        if (eventQuestion.html_form_input_id === this.html_form_input_id && eventQuestion.type === 'checkbox') {
          return true;
        }
        return false;
      });

      return question.length;
    },
  },
  watch: {
    'integration.conditional_delivery_criteria': {
      immediate: true,
      handler(criteria) {
        if (criteria) {
          this.html_form_input_id = criteria.html_form_input_id;
          this.constraint = criteria.constraint;
          this.value = criteria.value;
        }
      },
    },
  },
  methods: {
    clearConditionalLogic() {
      this.html_form_input_id = null;
      this.constraint = null;
      this.value = null;
    },
    handleSubmit() {
      const payload = {
        html_form_input_id: this.html_form_input_id,
        constraint: this.constraint,
        value: this.value,
      };
      this.$emit('conditional-logic:submit', payload);
    },
  },
};
</script>
<style scoped lang="scss">
.MappingQuestionsContainer {
  border: 1px solid #E3E3E3;
  border-radius: 8px;
  background-color: #FFFFFF;
  box-shadow: 0 13px 29px 0 rgba(0,0,0,0.11);
  padding-bottom: 25px;

.Heading {
    padding: 21px 30px;
    border-bottom: 1px solid lightgray;
    margin: 0;
  }
.CheckboxTypeDropdown {
  margin-top: 20px;
}
  .Logic {
    background-color: #f7f7f7;
    border: 1px solid #d3d3d3;
    border-radius: 4px;
    padding: 30px;
    margin: 20px 0;
  }
}

.StepNumber {
  margin-right: 5px;
}

.ResetDeliveryCriteria{
  margin-left: 15px;
}

::v-deep.ConditionalContainer{
  .Form-label{
    margin-bottom: 15px;
  }

  .Form-autoComplete{
    margin-right: 15px!important;
  }
}
</style>
